import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { ScrollManager } from './components/ScrollManager';
import { CaseStudyAccessProvider } from './contexts/CaseStudyAccessContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Home } from './pages/Home';
import { KordisCaseStudy } from './pages/KordisCaseStudy';
import { ClearDocsCaseStudy } from './pages/ClearDocsCaseStudy';
import { PalacioCaseStudy } from './pages/PalacioCaseStudy';
import { VendooCaseStudy } from './pages/VendooCaseStudy';
import { CognitiveBiases } from './pages/CognitiveBiases';
export function App() {
  return <ThemeProvider data-id="element-0" data-mp="2wka20ve6b74d">
    <MotionConfig reducedMotion="user" data-id="element-1" data-mp="2wjqhd6x524mn">
      <BrowserRouter data-id="element-2" data-mp="2wip7v6vrtq71">
        <ScrollManager data-id="element-3" data-mp="2wi5qbra193tj" />
        <CaseStudyAccessProvider data-id="element-4" data-mp="28tw4wqgqei2x">
          <Routes data-id="element-5" data-mp="28suumo7jhzm9">
            <Route path="/" element={<Home data-id="element-7" data-mp="23vci6nubd29i" />} data-id="element-6" data-mp="28sbb5328r364" />
            <Route path="/work/kordis" element={<KordisCaseStudy data-id="element-9" data-mp="23utadzydnu97" />} data-id="element-8" data-mp="23w4fc33k781w" />
            <Route path="/work/clear-docs" element={<ClearDocsCaseStudy data-id="element-11" data-mp="3iiweonbohg2p" />} data-id="element-10" data-mp="3ijxqiu0iq6lh" />
            <Route path="/work/palacio-de-hierro" element={<PalacioCaseStudy data-id="element-13" data-mp="3ml17jjuay8oa" />} data-id="element-12" data-mp="3ihv2gfixenje" />
            <Route path="/work/vendoo" element={<VendooCaseStudy data-id="element-15" data-mp="3rc9du70c5dx8" />} data-id="element-14" data-mp="3mjztr7lwj82v" />
            <Route path="/playground/cognitive-biases" element={<CognitiveBiases data-id="element-17" data-mp="3reltuemj9e7n" />} data-id="element-16" data-mp="3rbzq6q2rjiup" />
            <Route path="*" element={<Home data-id="element-19" data-mp="4n4pyuukj8z" />} data-id="element-18" data-mp="6hq1ea16ddl" />
          </Routes>
        </CaseStudyAccessProvider>
      </BrowserRouter>
    </MotionConfig>
    </ThemeProvider>;
}